export default {
  _account: 'compte',
  _action: 'Action',
  _actions: 'Actions',
  _add: 'Ajouter',
  _address1: 'Adresse',
  _address2: 'Complément d\'adresse',
  _all: 'Tous',
  _allow: 'Autoriser',
  _and: 'et',
  _annulable: 'Annulable',
  _autologin_url: 'URL de connexion automatique',
  _autologin_user: 'Utilisateur autologgé',
  _ask: 'demander',
  _bba_contact: 'Contact BBA',
  _by: 'par',
  _back: 'Retour',
  _back_list: 'retour à la liste',
  _back_sheet: 'retour à la fiche',
  _bedType: "Type de lit",
  _between: "entre",
  _body_text: "Contenu texte",
  _body_html: "Contenu HTML",
  _booking: 'Réservation | Réservations',
  _booking_base_id: "Ref FileMaker",
  _bookinginputfield: "Référence de réservation | Références de réservation",
  _cancel: 'Annuler',
  _cancel_day: "Nb. jours avant arrivée annulation sans frais",
  _cancel_hour: "Heure limite annulation sans frais",
  _cancellation_deadline: 'Date limite d\'annulation',
  _cancellation_link: 'Lien d\'annulation direct',
  _category: 'Catégorie',
  _comment: 'Commentaire',
  _configcontingent: 'Configurations de contingents',
  _confirm: 'Confirmer',
  _consultation_link: 'Lien de consultation direct',
  _content: 'Contenu',
  _contingent: 'Contingents',
  _contingent_hotelgamme: 'Types de chambres',
  _contingent_configcontingent: 'Configurations de contingents',
  _contingent_contingent: 'Contingents',
  _contingent_hotelretrocession: 'Configurations de rétrocessions',
  _contingent_retrocession: 'Rétrocessions',
  _contingent_bookingcontingent: 'Réservations',
  _contingent_date: 'Date de contingent',
  _contingent_email: 'Email(s) de notification',
  _hoteluser_email: 'Email de connexion',
  _hotel_user: 'Email de connexion',
  _company: 'Société',
  _companyfavorite: 'Lieux et hôtels favoris',
  _country: 'Pays',
  _create: 'créer',
  _created_at: 'Date de création',
  _created_by: 'Créé par',
  _custom_fields: 'Champs personnalisés',
  _date: {
    default: 'Date',
    on_the: 'le'
  },
  _dates: 'Dates',
  _date_contingent: 'Date du contingent',
  _days: 'Jours',
  _define_password: "Mot de passe oublié ?",
  _delete: 'Supprimer',
  _delete_question: "Souhaitez-vous vraiment supprimer cette entité ?",
  _delete_confirm: "L'entité a été supprimée",
  _deny: 'Refuser',
  _default_value: "Valeur par défault",
  _description: 'Description',
  _deselect: 'Déselectionner',
  _desired_city: 'Ville désirée',
  _desired_hotel: 'Hôtel souhaité',
  _desired_location: 'Localisation souhaitée',
  _destination: 'Destination',
  _details: 'Détails',
  _disable: 'Désactiver',
  _disable_relance_auto: 'Désactiver la relance automatique',
  _distance: 'Distance',
  _double: 'Double couchage',
  _duplicate: 'Dupliquer',
  _edit: 'Modifier',
  _edit_draft: 'Finaliser',
  _edit_link: 'Lien de modification direct',
  _email: 'Email',
  _email2: 'Email 2',
  _add_email_copies:'Ajouter des emails en copie',
  _email_copies: 'Ajouter des emails en copie',
  _email_copies_elior: "Ajouter l'adresse av00(n°CDPF)@elior.com et éventuellement une adresse email personnelle",
  _emergency_contact: "Numéro d'urgence",
  _emergency_contact_company: "Numéro d'urgence de la société",
  _enter_email_copie:'Entrer l\'adresse email en copie',
  _enter_email_copie_elior: "Entrer une adresse email",
  _empty_list: 'Compléter la recherche',
  _enable: 'Activer',
  _enabled: 'Actif',
  _ending_date: 'Date de fin',
  _error_message: "Message d'erreur",
  _false: 'non',
  _female: 'Mme',
  female: 'Mme',
  _field_type: {
    default: "Type",
    values: {
      10: "Numérique",
      20: "Texte",
      30: "Menu déroulant",
      40: "Booléen",
      50: "Paragraphe"
    }
  },
  _fields_white_mark: 'Marque blanche',
  _filter: {
    filtering: 'Filtrer',
    list: 'Filtrer la liste'
  },
  _filter_email_notifs: 'Exclusion notifications demandes de réservation',
  _first_name: 'Prénom',
  _for: 'pour',
  _gender: 'Civilité',
  _gender_short: 'Civ.',
  _gender_male_short: 'M.',
  _gender_female_short: 'Mme',
  _general: 'Général',
  _go: 'Y aller',
  _geo_lat: 'GPS Lat.',
  _geo_lng: 'GPS Long.',
  _help: 'Aide en ligne',
  _hide_menu: 'Masquer le menu',
  _home: 'Accueil',
  _home_page: 'Page d\'accueil',
  _hotel: 'Hôtel',
  _hotel_hotelgamme: 'Types de chambres',
  _hotel_configcontingent: 'Configurations de contingents',
  _hotel_contingent: 'Contingents',
  _hotel_hotelretrocession: 'Configurations de rétrocessions',
  _hotel_retrocession: 'Rétrocessions',
  _hotel_bookingcontingent: 'Réservations',
  _hotel_gamme: 'Type de chambre',
  _hotelgamme: 'Type de chambre',
  _hotelretrocession: 'Configuration de rétrocession',
  _hotelgammes: 'Nombre de types de chambres',
  _hotel_gammes: 'Nombre de types de chambres',
  _hotel_retrocessions: 'Nombre de rétrocessions',
  _hrs_ref: 'Référence HRS',
  _hrs_search_enabled: 'Recherche HRS',
  _hrs_process_key: "N° de réservation",
  _hrs_process_password: "Code d'accès",
  _ie_not_allowed: "Cette application ne supporte pas le navigateur Internet Explorer. Pourquoi ne pas essayer avec&nbsp<a href=\"https://www.mozilla.org/fr/firefox/new/\" target='\"_blank\"'>Mozilla Firefox</a>&nbsp?",
  _image: 'Image',
  _impersonate: "Incarner",
  _disable_booking: "Désactiver",
  _disable_hotel_retrocession: "Désactiver",
  _enable_hotel_retrocession: "Activer",
  _enable_virtual_card: "Activer la carte virtuelle",
  _included: 'dont',
  _is_etape: 'Etape',
  _is_manager: 'Manager',
  _is_online: "Online",
  _is_user: "Utilisateur",
  _is_traveller: "Voyageur",
  _job: 'Fonction',
  _journey_dates: 'Dates du séjour',
  _label: "Libellé",
  _landline: 'Téléphone fixe',
  _phone: 'Téléphone',
  _phone_number_company: 'Téléphone de la société',
  _last_name: 'Nom',
  _less_than: "Moins de",
  _list: 'Liste',
  _location: 'Lieu',
  _login: 'Identifiant',
  _loading: 'En cours de chargement',
  _loading_error: 'Erreur de chargement',
  _logo_image: 'Logo',
  _logoImage: 'Logo',
  _logout: 'Déconnexion',
  _mail : 'Email',
  _mail_company : 'Email de la société',
  _mail_rcpt: "Destinataire(s)",
  _mail_bcc: "Destinataire(s) en copie cachée",
  _mass_edit: 'Edition de masse',
  _mass_edit_contingent: 'Modification contingent par période',
  _body: "Corps du message",
  _maillog: "Notifications",
  _male: 'M.',
  male: 'M.',
  _main_information:'Informations principales',
  _notMap: 'Pas de données de géolocalisation',
  _is_white_marking: 'Marque Blanche',
  _additional_information: 'Information(s) complémentaire(s)',
  _mobile_phone: 'Téléphone mobile',
  _modify: 'Modifier',
  _modify_my_search: 'Modifier ma recherche',
  _my_bookings: {
    title: 'Mes réservations',
    in_progress: 'Mes réservations en cours',
    history: 'Historique de réservations',
    to_do: 'Réservations à traiter',
    stats: 'Statistiques'
  },
  _my_research: 'ma recherche',
  _name: 'Nom',
  _new: 'Nouveau',
  _new_booking: 'Nouvelle réservation',
  _new_customer: 'nouveau client',
  _new_message: 'Nouveau message',
  _news: 'Les actualités',
  _no: 'Non',
  _no_data: "Aucune donnée disponible",
  _no_result_found: 'Aucun résultat trouvé',
  _notification_list: 'Notifications envoyées',
  _no_article: 'Aucun article',
  _notify_users: 'Notifier tous les utilisateurs',
  _offline_enabled: 'Mode Offline',
  _offline: 'Demande Offline',
  _online: 'Demande Online',
  _online_validate :'Terminer la réservation',
  _only_one: 'Only one',
  _opening_hours: "Heures d'ouverture",
  _opening_hours_company: "Horaires d'ouverture",
  _order_number_pattern: "Motif bon de commande",
  _page_title_list: 'Liste des',
  _page_title_show: 'Fiche',
  _password: 'Mot de passe',
  _payment_mode: 'Mode de paiement',
  _payment_modes: {
    onVirtualCreditCard: "@:DEBIT_CARTE_DE_CREDIT_BBA",
    direct: "@:REGLEMENT_SUR_PLACE",
    REGLEMENT_SUR_PLACE: "@:REGLEMENT_SUR_PLACE",
    PRISE_EN_CHARGE_BBA: "@:PRISE_EN_CHARGE_BBA",
    DEBIT_CARTE_DE_CREDIT_BBA: "@:DEBIT_CARTE_DE_CREDIT_BBA",
    DEBIT_AMERICAN_EXPRESS_BBA: "@:DEBIT_AMERICAN_EXPRESS_BBA",
    DEBIT_CARTE_AIRPLUS_BBA: "@:DEBIT_CARTE_AIRPLUS_BBA",
    DEBIT_CARTE_VIRTUELLE_BNP: "@:DEBIT_CARTE_VIRTUELLE_BNP",
    PREPAIEMENT_BBA: "@:PREPAIEMENT_BBA",
    contingent: '@:VIREMENT_BBA',
    contingent_virtual_card: '@:CARTE_VIRTUELLE_BBA'
  },
  _per_date: 'Par date',
  _per_hotel: "Par hôtel",
  _perRoomPerDay: "/ chambre / jour",
  _perPersonPerDay: "/ personne / jour",
  _period: {
    from: 'du',
    to: 'au'
  },
  _phone_number: 'Téléphone',
  _placeholder: "Placeholder",
  _post_code: 'Code postal',
  _prix_achat: 'Prix ch. & pdj',
  _prix_vente: 'Prix de vente',
  _prix_achat_etape: 'Prix soirée étape',
  _prix_vente_etape: 'Prix de vente étape',
  _generic_request: "Demande de réservation",
  _prelogged_request: 'Demande de réservation d\'hôtel pour votre formation',
  _prelogged_user: "Utilisateur pré-loggué",
  _prix_default: 'Prix par défaut',
  _please_choose: 'Veuillez choisir',
  _position: "Position",
  _price: 'Prix',
  _qte: "Quantité",
  _qte_default: 'Qté par défaut',
  _qte_init: 'Qté initiale',
  _qte_resa: 'Qté réservée',
  _qte_retro: 'Qté rétrocédée',
  _qte_dispo: 'Qté disponible',
  _quantite: 'Quantité',
  _rank: "Ordre d'apparition",
  _rate: 'Note',
  _read_less: 'Réduire',
  _read_more: 'Lire la suite',
  _read_only: "Lecture seule",
  _ref: "Référence",
  _remove: 'Retirer',
  _required: "Obligatoire",
  _resend: "Réenvoyer",
  _reset: 'Réinitialiser',
  _reset_all:'Réinitialiser tous les filtres',
  _reset_filters: 'Supprimer les filtres',
  _result: 'résultat | résultats',
  _retrocession: 'Rétrocessions',
  _role: 'Rôle',
  _roles: 'Rôle(s)',
  _rooms: {
    single: 'Occupation par 1 personne',
    double: 'Occupation par 2 personnes',
    one: 'Occupation par 1 personne',
    two: 'Occupation par 2 personnes'
  },
  _send: 'Envoyer',
  _send_request: 'Envoyer la demande',
  _save_form: 'Sauvegarder en brouillon',
  _show: 'Fiche',
  _show_list: 'Voir la liste',
  _show_map: 'Voir la carte',
  _hide_map: 'Masquer la carte',
  _show_menu: 'Afficher le menu',
  _single: 'Simple couchage',
  _search: 'Rechercher',
  _select: 'Sélectionner',
  _select_date: 'Sélectionnez une date',
  _select_option: "Sélectionner une option",
  _select_traveller: "Veuillez sélectionner le voyageur {nb}",
  _send_code: "Etat d'envoi",
  _sort: 'Trier',
  _starting_date: 'Date de début',
  _status: 'Statut',
  _subject: "Sujet",
  _arrival_date: 'Date d\'arrivée',
  _departure_date: 'Date de départ',
  _survey_question: 'Enquête de satisfaction',
  _taux: 'Taux',
  _taxe_sejour: 'Taxe de séjour',
  _template: "Template",
  _text_length: "Longueur du texte",
  _that_is_to_say: 'soit',
  _threshold_survey: 'Seuil de déclenchement de l\'enquête utilisateur',
  _threshold_survey_traveller: 'Seuil de déclenchement de l\'enquête voyageur',
  _time: {
    from: 'de',
    to: 'à'
  },
  _city: 'Ville',
  _title: 'Titre',
  _travel_policy: 'Politique de voyage',
  _traveller: 'Voyageur',
  _traveller_new: 'nouveau voyageur',
  _traveller_add: 'Ajouter un nouveau voyageur',
  _traveller_drag: 'Glissez ici le voyageur ',
  _travellers: 'Voyageurs',
  _true: 'oui',
  _type: 'Type',
  _unauthorised: 'Vous n\'êtes pas autorisé à accéder à cette page',
  _undefined: "Non défini",
  _until: 'jusqu\'au',
  _until_day: 'jusqu\'au',
  _until_time: 'jusqu\'à',
  _updated_at: 'Date de mise à jour',
  _updated_by: 'Modifié par',
  _user_add: 'Ajouter un nouvel utilisateur',
  _user_s: 'Utilisateur | Utilisateurs',
  _traveller_s: "Voyageur | Voyageurs",
  _user: 'Utilisateur',
  _validate: 'Valider',
  _vat: 'TTC',
  _wait: "Veuillez patienter",
  _website: 'Site Web',
  _weight: 'Poids',
  _yes: 'Oui',
  _you: 'vous',
  _btn_hotel_detail: 'détail des tarifs',
  _btn_hotel_discover: 'découvrir',
  _hotel_cancel_date: 'annulation',
  _btn_room_book: 'Je réserve',
  _create_account: 'créer un compte',
  login: {
    form: {
      submit: 'Connexion'
    },
    to_account: 'me connecter à mon compte',
    remain_connected: 'rester connecté(e)',
    forgotten_password: {
      text: 'mot de passe oublié',
      error: {
        noEmail: 'Veuillez saisir votre adresse email',
        wrongEmail: "Adresse email inconnue",
      },
      email_sent_to: 'Afin de redéfinir votre mot de passe, un email vient d\'être envoyé à',
      get_back_password: 'Récupérer son mot de passe'
    }
  },
  location: {
    form: {
      is_blank_error: 'Ce champ est requis'
    }
  },
  logout: {
    verb: 'Se déconnecter',
    cancelImpersonate: "Se désincarner",
  },
  form: {
    submit: 'Enregistrer'
  },
  _no_booking_access: {
    phrase: 'La configuration de votre compte société ne vous permet pas d\'effectuer des réservations, merci de ',
    contact: 'contacter votre agent BBA'
  },
  _textarea:{
    phrase: {
      offline: "Arrivée tardive, hôtel en particulier, contraintes spécifiques, soirée étape...",
      online: "Arrivée tardive, contraintes spécifiques, soirée étape..."
    }
  },
  _tooltip:{
    upload: "Joindre un fichier (max 10 Mo)"
  },
  _multiselect: {
    selectLabel: "Sélectionner",
    selectedLabel: "Sélectionné",
    deselectLabel: "Désélectionner"
  },
  _exclude_online_non_free_cancellation: "@:company.excludeOnlineNonFreeCancellation",
  _exclude_online_unknown_breakfast: "@:company.excludeOnlineUnknownBreakfast",
  _require_hrs_payment: "@:company.requireHrsPayment",
  _max_price_per_room: "@:booking.maxPricePerRoom",
  _meal_price_contribution: "@:booking.meal_contribution",
  _booking_fees_global: "@:company.bookingFees.title @:company.bookingFees.global",
  _booking_fees_global_offline: "@:company.bookingFees.title @:company.bookingFees.global Offline",
  _booking_fees_global_online: "@:company.bookingFees.title @:company.bookingFees.global Online",
  _booking_fees_global_label: "Libellé des @:_booking_fees_global",
  _booking_fees_per_room: "@:company.bookingFees.title @:company.bookingFees.perRoom",
  _booking_fees_per_room_offline: "@:company.bookingFees.title @:company.bookingFees.perRoom Offline",
  _booking_fees_per_room_online: "@:company.bookingFees.title @:company.bookingFees.perRoom Online",
  _booking_fees_per_room_label: "Libellés des @:_booking_fees_per_room",
  _perRoom: "par chambre",
  _orderNumber: "Bon de commande",
  _order_number_required: "Bon de commande requis",
  _order_number_label: "Libellé bon de commande",
  _order_number_fill: "Saisir le bon de commande",
  _browse: "Parcourir",
  fileInput: {
    browse: "Parcourir",
    placeholder: "Sélectionner ou déposer un fichier",
    drop: "Glisser le fichier ici"
  },
  _bookinghistory: "Statuts",
  bookinghistory: {
    list: {
      date: "Date",
      page_title: "@:_bookinghistory"
    }
  },
  _require_manager_pre_validation: "Pré-validation",
  _require_manager_post_validation: "Post-validation",
  _require_manager_post_validation_travel_policy_dont_suit: "Post-validation Politique de voyage non conforme",
  _kkey: "KKEY",
  _notifyTravellers: "Envoyer le voucher aux voyageurs automatiquement",
  _sendToTravellers: "Envoyer aux voyageurs",
  _enterAddresses: "Saisir les destinataires",
  _whatToDo: "Que voulez-vous faire ?",
  _config: "Configuration",
  _yourContact: "Votre contact",
  _multi_manager_enabled: "Mode Multi Manager",
  _openAttachment: "Ouvrir la pièce jointe",
  _attachFile: "Joindre un fichier",
  _managersList: "Liste des managers de la société",
  _import: "Importer",
  _crsReservationKey: "Numéro de réservation de l'hôtel",
  _value:"Valeur"
}
